// extracted by mini-css-extract-plugin
export var alternate = "_r-h";
export var black = "_r-3";
export var blue = "_r-d";
export var blueLight = "_r-c";
export var brand = "_r-7";
export var error = "_r-9";
export var gray = "_r-6";
export var grayBlue = "_r-b";
export var iconWrapper = "_r-4";
export var indigo = "_r-e";
export var orange = "_r-g";
export var pink = "_r-f";
export var primary = "_r-0";
export var purple = "_r-8";
export var success = "_r-5";
export var warning = "_r-a";
export var white = "_r-1";
export var whiteSuccess = "_r-2";